import { AlertConditionType, variableType } from '../types';

export const alertConditionValidator = (alertCondition: AlertConditionType) => {
  const isVariableFilled = !!alertCondition.variable;
  const isThresholdValid = thresholdValidator(
    alertCondition.variable, Number(alertCondition.threshold))
  const isTimeRangeValid = Number(alertCondition.timerange) <= 36
  return {isVariableFilled, isThresholdValid, isTimeRangeValid};
};

const thresholdValidator = (variable: variableType, threshold:number) => {
  let isValid
    isValid =  (threshold >= minimumValueForEachVariables[variable])
    return {variable, isValid}
}

export const minimumValueForEachVariables:{[key in variableType]:number} = {
  floodForecast: 10,
  precipitation:5,
  waterLevel:1
}
